import { useState, useEffect, lazy, Suspense } from 'react'

const InteractiveWorkflowPreview = lazy(() => import('./InteractiveWorkflowPreview'))

const WORKFLOW_PROMPTS = [
  'a neon city cyberpunk race',
]

export default function WorkflowSection() {
  const [currentPrompt, setCurrentPrompt] = useState('')
  const [charIndex, setCharIndex] = useState(0)
  const [isDone, setIsDone] = useState(false)

  useEffect(() => {
    if (isDone) return
    
    const currentText = WORKFLOW_PROMPTS[0]
    
    const timeout = setTimeout(() => {
      if (charIndex < currentText.length) {
        setCurrentPrompt(currentText.substring(0, charIndex + 1))
        setCharIndex(charIndex + 1)
      } else {
        setIsDone(true)
      }
    }, 50)

    return () => clearTimeout(timeout)
  }, [charIndex, isDone])

  return (
    <div className="workflow-section">
      <h2 className="workflow-heading">A creative studio in one prompt</h2>
      <p className="workflow-subtitle">
        Make a story about... <span className="typing-text">{currentPrompt}<span className="typing-cursor">|</span></span>
      </p>
      <div className="workflow-canvas-container">
        <Suspense fallback={
          <div className="workflow-image-container">
            <img 
              src="/prototype/images/Example.png" 
              alt="AI Production Workflow" 
              className="workflow-image"
            />
          </div>
        }>
          <InteractiveWorkflowPreview />
        </Suspense>
      </div>
    </div>
  )
}
